module.exports = "/_next/static/images/SeattleLogo-2b0553c12a4f127b7074083634febd3a.png";